/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import { AnyAction, CombinedState, combineReducers } from 'redux';
/* NPM Imports End */

/* Project Imports Start */
import userReducer from './userReducer';
import reportReducer from './reportReducer';
import customerReducer from './customerReducer';
import siteandequReducer from './siteandequReducer';
import checklistReducer from './checklistReducer';
import datatableReducer from './datatableReducer';
import issuechartReducer from './issuechartReducer';
import issuegalleryReducer from './issuegalleryReducer';
import issuepunchlistReducer from './issuepunchlistReducer';
import reportphotoReducer from './reportphotoReducer';
import configuration from './configurationReducer';
import reportViewerReducer from './reportViewerReducer';
/* Project Imports End */

/* CCS & Image imports Start */

/* CCS & Image imports End */

const appReducer = combineReducers({
  user: userReducer,
  reports: reportReducer,
  customer: customerReducer,
  siteandequ: siteandequReducer,
  checkList: checklistReducer,
  datatable: datatableReducer,
  issuechart: issuechartReducer,
  issuegallery: issuegalleryReducer,
  issuepunchlist: issuepunchlistReducer,
  reportphoto: reportphotoReducer,
  configuration,
  reportViewerReducer,
});

// Define the RootState type
export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (
  state: RootState | undefined,
  action: AnyAction,
): CombinedState<RootState> => {
  if (action.type === 'RESET_REDUX_STATE') {
    state = undefined;
  }
  return appReducer(state, action);
};
export default rootReducer;
